import { render, staticRenderFns } from "./lowPriceWaitOperated.vue?vue&type=template&id=d4e1d4b4"
import script from "./lowPriceWaitOperated.vue?vue&type=script&lang=js"
export * from "./lowPriceWaitOperated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports